<template>
  <div class="memo_operation_box" :class="{is_mobile: isMobile}" @click="close">
    <div class="memo_operation" @click.stop>
      <div class="op_title">
        <span v-if="!isEdit">新增备忘</span><span v-else>修改备忘</span>
      </div>
      <div class="op_content">
        <div class="op_row required">
          <span class="op_label">标题：</span>
          <input class="op_input" type="text" v-model="params.title" placeholder="请输入标题">
        </div>
        <div class="op_row">
          <span class="op_label">内容：</span>
          <textarea class="op_textarea" v-model="params.content" placeholder="补充说明（选填）"></textarea>
        </div>
        <div class="op_row">
          <span class="op_label">象限：</span>
          <div class="quadrant_select">
            <div class="q_option" v-for="q in quadrantOptions" :key="q.value" :class="['q' + q.value, {selected: params.quadrant === q.value}]" @click="params.quadrant = q.value">
              {{q.label}}
            </div>
          </div>
        </div>
        <div class="op_row">
          <span class="op_label">分类：</span>
          <input class="op_input" type="text" v-model="params.tag" placeholder="如：工作,生活（逗号分隔，选填）">
        </div>
        <div class="op_row">
          <span class="op_label">优先级：</span>
          <select class="op_select" v-model="params.priority">
            <option :value="0">无</option>
            <option :value="1">低</option>
            <option :value="2">中</option>
            <option :value="3">高</option>
          </select>
        </div>
        <div class="op_row">
          <span class="op_label">截止日期：</span>
          <input class="op_input" type="date" v-model="params.deadline">
        </div>
      </div>
      <div class="op_buttons">
        <div v-if="!isEdit" class="op_btn add_btn" @click="submit">添加</div>
        <div v-if="isEdit" class="op_btn edit_btn" @click="submit">修改</div>
        <div class="op_btn cancel_btn" @click="close">取消</div>
      </div>
    </div>
    <div @click.stop>
      <pop ref="opPop" :title="popMessage" cancel-text="知道了" :show-sure="false" @cancel="closePop" />
    </div>
  </div>
</template>

<script>
import pop from '@/component/pop/pop.vue'
import { addMemo } from '@/vue_api/memo.js'

export default {
  name: 'memoOperation',
  components: {
    pop
  },
  data() {
    return {
      popMessage: '',
      params: {
        id: null,
        title: '',
        content: '',
        quadrant: 1,
        status: 0,
        tag: '',
        priority: 0,
        deadline: ''
      },
      quadrantOptions: [
        { value: 1, label: '重要&紧急' },
        { value: 2, label: '重要&不紧急' },
        { value: 3, label: '不重要&紧急' },
        { value: 4, label: '不重要&不紧急' }
      ],
      isEdit: false,
      isMobile: false
    }
  },
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    this.isEdit = !!this.item.id
    if (this.isEdit) {
      this.params = {
        id: this.item.id,
        title: this.item.title || '',
        content: this.item.content || '',
        quadrant: this.item.quadrant || 1,
        status: this.item.status || 0,
        tag: this.item.tag || '',
        priority: this.item.priority || 0,
        deadline: this.item.deadline ? String(this.item.deadline).slice(0, 10) : ''
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 500
    },
    submit() {
      if (!this.params.title.trim()) {
        this.showPop('标题不能为空')
        return
      }
      const data = {
        ...this.params,
        editor: this.userName,
        deadline: this.params.deadline ? this.params.deadline + ' 23:59:59' : null
      }
      addMemo(data).then(res => {
        if (res.data.status) {
          this.$emit('success')
        } else {
          this.showPop(res.data.message || '操作失败')
        }
      })
    },
    showPop(message) {
      this.popMessage = message
      this.$refs.opPop.open()
    },
    closePop() {
      this.$refs.opPop.close()
    },
    close() {
      this.$emit('update:operation', 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.memo_operation_box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;

  .memo_operation {
    background: #fff;
    border-radius: .08rem;
    padding: .2rem;
    width: 5.5rem;
    max-width: 90vw;
    max-height: 85vh;
    overflow-y: auto;

    .op_title {
      font-size: .18rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: .15rem;
    }

    .op_content {
      .op_row {
        display: flex;
        align-items: flex-start;
        margin-bottom: .12rem;

        &.required .op_label::before {
          content: '*';
          color: #c62828;
          margin-right: .02rem;
        }

        .op_label {
          font-size: .14rem;
          width: .8rem;
          flex-shrink: 0;
          line-height: .35rem;
          text-align: right;
          padding-right: .08rem;
        }

        .op_input {
          flex: 1;
          height: .35rem;
          padding: 0 .1rem;
          border: 1px solid #ddd;
          border-radius: .04rem;
          font-size: .14rem;
          outline: none;

          &:focus {
            border-color: rgba(102, 153, 204, 1);
          }
        }

        .op_textarea {
          flex: 1;
          height: .8rem;
          padding: .08rem .1rem;
          border: 1px solid #ddd;
          border-radius: .04rem;
          font-size: .14rem;
          outline: none;
          resize: vertical;

          &:focus {
            border-color: rgba(102, 153, 204, 1);
          }
        }

        .op_select {
          flex: 1;
          height: .35rem;
          padding: 0 .1rem;
          border: 1px solid #ddd;
          border-radius: .04rem;
          font-size: .14rem;
          outline: none;
          background: #fff;
        }

        .quadrant_select {
          flex: 1;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: .06rem;

          .q_option {
            text-align: center;
            padding: .06rem 0;
            border-radius: .04rem;
            font-size: .13rem;
            cursor: pointer;
            border: 1px solid transparent;
            transition: all 0.15s;

            &.q1 { background: rgba(244, 67, 54, 0.1); color: #c62828; }
            &.q2 { background: rgba(255, 152, 0, 0.1); color: #e65100; }
            &.q3 { background: rgba(255, 193, 7, 0.1); color: #f57f17; }
            &.q4 { background: rgba(76, 175, 80, 0.1); color: #2e7d32; }

            &.selected {
              border-color: currentColor;
              font-weight: bold;
            }
          }
        }
      }
    }

    .op_buttons {
      display: flex;
      justify-content: center;
      gap: .15rem;
      margin-top: .15rem;

      .op_btn {
        padding: .08rem .3rem;
        border-radius: .04rem;
        cursor: pointer;
        font-size: .14rem;
        transition: opacity 0.15s;

        &:hover {
          opacity: 0.85;
        }
      }

      .add_btn, .edit_btn {
        background: rgba(102, 153, 204, 1);
        color: #fff;
      }

      .cancel_btn {
        background: #eee;
        color: #333;
      }
    }
  }
}

.memo_operation_box.is_mobile {
  align-items: flex-end;

  .memo_operation {
    width: 100%;
    max-width: 100vw;
    max-height: 90vh;
    border-radius: .08rem .08rem 0 0;
    padding: .15rem .12rem;

    .op_title {
      font-size: .16rem;
    }

    .op_content {
      .op_row {
        flex-direction: column;
        margin-bottom: .1rem;

        .op_label {
          width: auto;
          text-align: left;
          padding-right: 0;
          margin-bottom: .04rem;
          line-height: 1.4;
        }

        .op_input {
          height: .36rem;
          font-size: .14rem;
        }

        .op_textarea {
          height: .6rem;
          font-size: .14rem;
        }

        .op_select {
          height: .36rem;
          font-size: .14rem;
        }

        .quadrant_select {
          .q_option {
            padding: .08rem 0;
            font-size: .14rem;
          }
        }
      }
    }

    .op_buttons {
      .op_btn {
        padding: .1rem .25rem;
        font-size: .15rem;
      }
    }
  }
}
</style>